export default __webpack_public_path__ + "static/media/tumorChannel3.9f6e78b0.png";